import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import DropzoneComponent from "react-dropzone-component";
import { connect } from "react-redux";
import cx from "classnames";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "!isomorphic-style-loader!css-loader!./filepicker.css";

import {
  doUploadProfilePicture,
  doRemoveProfilePicture,
} from "../../actions/manageUserProfilePicture";
import { setLoaderComplete, setLoaderStart } from "../../actions/loader/loader";
import showToaster from "../../helpers/showToaster";

import EditIcon from "/public/SiteIcons/profileEditIcon.svg";
import updateIcon from "/public/SiteIcons/writeIcon.svg";

class Dropzone extends Component {
  static propTypes = {
    doUploadProfilePicture: PropTypes.any.isRequired,
    doRemoveProfilePicture: PropTypes.any.isRequired,
    startProfilePhotoLoader: PropTypes.any.isRequired,
    formatMessage: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.success = this.success.bind(this);
    // this.removeExistingFile = this.removeExistingFile.bind(this);
    this.addedfile = this.addedfile.bind(this);
    this.dropzone = null;
  }

  componentDidUpdate() {
    const isBrowser = typeof window !== "undefined";
    const isDocument = typeof document !== undefined;
    if (isBrowser && isDocument) {
      document.querySelector(".dz-hidden-input").style.visibility = "visible";
      document.querySelector(".dz-hidden-input").style.opacity = "0";
      document.querySelector(".dz-hidden-input").style.height = "100%";
      document.querySelector(".dz-hidden-input").style.width = "100%";
      document.querySelector(".dz-hidden-input").style.cursor = "pointer";
    }
  }

  async success(file, fromServer) {
    const { setLoaderStart, setLoaderComplete } = this.props;
    const { doUploadProfilePicture, data } = this.props;
    let fileName = fromServer.file.filename;
    let oldPicture = data != undefined ? data.picture : null;
    await setLoaderStart("profilePhotoLoader");
    await doUploadProfilePicture(fileName, oldPicture);
    await setLoaderComplete("profilePhotoLoader");
  }

  addedfile(file) {
    const reader = new FileReader();

    reader.onloadend = () => {
      const arr = new Uint8Array(reader.result).subarray(0, 4);
      let header = "";
      for (let i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }

      let isValid = false;
      if (arr[0] === 0xff && arr[1] === 0xd8) {
        isValid = true; // JPG / JPEG
      }
      // Check PNG
      else if (
        arr[0] === 0x89 &&
        arr[1] === 0x50 &&
        arr[2] === 0x4e &&
        arr[3] === 0x47
      ) {
        isValid = true; // PNG
      }
      console.log(isValid, "isValid");

      if (!isValid) {
        this.dropzone.removeAllFiles(true); // clear all cached files
        showToaster({ messageId: "invalidType", toasterType: "error" });
        return;
      }

      // Proceed with upload
      this.dropzone.processFile(file);
    };

    reader.readAsArrayBuffer(file.slice(0, 4));
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { defaultMessage, isEditIcon, maxUploadSize, className } = this.props;
    const djsConfig = {
      dictDefaultMessage: "",
      addRemoveLinks: false,
      uploadMultiple: false,
      maxFilesize: maxUploadSize,
      acceptedFiles: "image/jpeg,image/png",
      dictMaxFilesExceeded: "Remove the existing image and try upload again",
      previewsContainer: false,
      hiddenInputContainer: ".dzInputContainer",
      maxFiles: 1,
      init: function () {
        this.on("addedfile", function (file) {
          if (this.files.length > 1) {
            this.removeFile(this.files[0]);
          }
        });
      },
    };
    const componentConfig = {
      iconFiletypes: [".jpg", ".jpeg", ".png"],
      postUrl: "/uploadProfilePhoto",
    };
    const eventHandlers = {
      init: (dz) => (this.dropzone = dz),
      success: this.success,
      addedfile: this.addedfile,
    };

    return (
      <>
        <div
          className={cx("dzInputContainer", "dashBoardDroupZone", className)}
        >
          <DropzoneComponent
            config={componentConfig}
            eventHandlers={eventHandlers}
            djsConfig={djsConfig}
          >
            {isEditIcon && <img src={EditIcon} className={"dropShadow"} />}
            {!isEditIcon && (
              <img src={updateIcon} className={cx("dropzoneImgSpace")} />
            )}
            {defaultMessage && defaultMessage}
          </DropzoneComponent>
        </div>
      </>
    );
  }
}

const mapState = (state) => ({
  account: state.account.data,
});

const mapDispatch = {
  doUploadProfilePicture,
  doRemoveProfilePicture,
  setLoaderStart,
  setLoaderComplete,
};

export default injectIntl(
  withStyles(s)(connect(mapState, mapDispatch)(Dropzone))
);
